function GuestGuard(props) {
  const { children } = props

  return children
}

export default GuestGuard
